import styled from '@emotion/styled';
import { mapStylesProp } from 'utils/styles';

export const A = styled('a')(mapStylesProp);
